import React from 'react'
import './HorizontalSimpleCard.scss'
import classNames from 'classnames'
import { CardProps, RailDetailsItem } from '@interfaces/index'
import { ImageSize } from '@enums/images.enum'
import { useImgUrlTransform } from '@hooks/useImgUrlTransform'
import { DocumentData } from 'firebase/firestore'
import Image from '@components/Image/Image'
import FallbackImage from '@components/FallbackImage/FallbackImage'

interface HorizontalSimpleCardProps {
  item: CardProps | RailDetailsItem | DocumentData
  isActive?: boolean
}

const HorizontalSimpleCard = ({ item, isActive }: HorizontalSimpleCardProps) => {
  const { id, title, contextData } = item
  const transformedImage = useImgUrlTransform(contextData?.imageCard, ImageSize.HORIZONTAL_CARD)

  return (
    <div
      className={classNames('hs-type', {
        'hs-type__full_opacity': isActive,
      })}
      id={`more-like-this-${id}`}
    >
      <div
        className={classNames('hs-type__focus', {
          'hs-type__focused': isActive,
        })}
      />
      <div className={classNames('card-image-wrapper', { 'row-card-image-focused': isActive })}>
        {contextData?.imageCard ? <Image image={transformedImage} alt={title} fallbackOnLoad /> : <FallbackImage />}
      </div>
    </div>
  )
}
export default HorizontalSimpleCard
